import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../app.constants';
import { BehaviorSubject } from '../../../../node_modules/rxjs';
import { ToastService } from '../../shared/services/toast.service';
@Injectable({
  providedIn: 'root'
})
export class ExportHubService {

  public selectedCollection_Beh = new BehaviorSubject<string>('');
  public selectedCollection_Obs = this.selectedCollection_Beh.asObservable();
  public selectedCollectionFields_Beh = new BehaviorSubject<any>({});
  public selectedCollectionFields_Obs = this.selectedCollectionFields_Beh.asObservable();
  public reportData_Beh = new BehaviorSubject<any>(null);
  public report_pagination = new BehaviorSubject<any>(null);
  public reportData_Obs = this.reportData_Beh.asObservable();
  public report_pagination_Obs = this.report_pagination.asObservable();

  public selectionFields_Beh = new BehaviorSubject<any>([]);
  public selectionFields_Obs = this.selectionFields_Beh.asObservable();

  constructor(
    private _http: HttpClient,
    private config: Configuration,
    public toastService: ToastService
  ) { }

  public selectionFieldsChange(val, queryFlag:boolean) {
    this.selectionFields_Beh.next({val, queryFlag});
  }

  public collectionChanged(collName, collFields) {
    this.selectedCollectionFields_Beh.next(collFields);
    this.selectedCollection_Beh.next(collName);
  }
  public reportDataPagination(paginate) {
    this.report_pagination.next(paginate);
  }

  public getExportableFields() {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/getCardsAndFields`, {}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public exportAcitveAssociates(shouldGroupIdExist) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/exportAcitveAssociates`, { shouldGroupIdExist: shouldGroupIdExist }).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
        this.toastService.error('No Data to export');
      });
    });
  }

  public exportProductMedia(val: boolean) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/exportProductMedia`, { productMediaQuery: val }).subscribe(values => {
        ok(values);
        this.toastService.successWithMessage('A link to data will be emailed to you within an hour.');
      }, err => {
        notOk(err);
        this.toastService.error('Unable to export at this moment');
      });
    });
  }

  public exportInactiveAssociates() {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/exportInactiveAssociates`, {}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public exportSites() {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/exportSites`, {}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public exportVendorsList() {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/exportVendorsList`, {}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public getSavedQueries() {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/getSavedQueries`, {}).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public exportCollection(skip, limit, query, productMediaQuery) {
    this.reportData_Beh.next({results:[]});
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/exportCollection/${skip * limit}/${limit}`, query).subscribe(values => {
        if (values && values['results'] !== 'ok') {
          this.reportData_Beh.next(values);
          ok(values);
        } else if (values['results'] === 'ok') {
          // this.reportData_Beh.next({ results: [] });
          this.toastService.successWithMessage('A link to data will be emailed to you within 30 minutes.');
          ok(values);
        }
        if (productMediaQuery) {
          // this.reportData_Beh.next({ results: [] });
          this.toastService.successWithMessage('A link to data will be emailed to you within an hour.');
          ok(values);
        }
      }, err => {
        notOk(err);
      });
    });
  }

  public exportCollectionSecondary(skip, limit, query, productMediaQuery) {
    this.reportData_Beh.next({results:[]});
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/exportCollection2/${skip * limit}/${limit}`, query).subscribe(values => {
        if (values && values['results'] !== 'ok') {
          this.reportData_Beh.next(values);
          ok(values);
        } else if (values['results'] === 'ok') {
          // this.reportData_Beh.next({ results: [] });
          this.toastService.successWithMessage('A link to data will be emailed to you within 30 minutes.');
          ok(values);
        }
        if (productMediaQuery) {
          // this.reportData_Beh.next({ results: [] });
          this.toastService.successWithMessage('A link to data will be emailed to you within an hour.');
          ok(values);
        }
      }, err => {
        notOk(err);
      });
    });
  }

  public saveNewQuery(collName, query) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/saveQuery`, { collName: collName, query: query }).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }

  public updateQuery(queryId, query) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/updateQuery`, { queryId: queryId, query: query }).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }
  public deleteQuery(queryId) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/deleteQuery`, { queryId: queryId }).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }
  public getExportHubLogs(query={}) {
    return new Promise((ok, notOk) => {
      this._http.post(`${this.config.ServerApiUrl}/exports/exportHubLogs`, { query: query }).subscribe(values => {
        ok(values);
      }, err => {
        notOk(err);
      });
    });
  }
}
